module.exports = __webpack_public_path__ + "static/img/bread.e7d35e5.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/bread.svg
// module id = 0XU3
// module chunks = 1